import { createSelector } from '@reduxjs/toolkit';
import { DefaultRootState } from 'react-redux';
import { filterOptionSelector } from '../../layout/selectors/layout.selectors';
import { emptyMessageContent } from '../client/helpers';
import {
  selectAll,
  selectById,
  selectEntities,
} from '../reducers/morphology.reducer';

const morphologySelector = ({ morphology }: DefaultRootState) => morphology;

export const morphologiesSelector = createSelector(
  morphologySelector,
  selectAll,
);

export const morphologyEntitiesSelector = createSelector(
  morphologySelector,
  selectEntities,
);

export const morphologyByIdSelector = (morphologyId: number) =>
  createSelector(morphologySelector, (state) =>
    selectById(state, morphologyId),
  );

export const filteredMorphologiesSelector = createSelector(
  morphologiesSelector,
  filterOptionSelector,
  (morphologies, filterOption) =>
    filterOption === 'All'
      ? morphologies
      : morphologies.filter(
          (morphology) => morphology.classification === filterOption,
        ),
);

export const emptyMessageMorphologySelector = createSelector(
  filterOptionSelector,
  (filterOption) => {
    if (filterOption === 'Noise') {
      return emptyMessageContent['noNoiseMorphologies'];
    }
    return emptyMessageContent['default'];
  },
);
